import { DhlLink as NewLink } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for Link component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const Link = (props) => {
  const { children, ...rest } = props;

  return <NewLink {...rest}>{children}</NewLink>;
};

Link.propTypes = {
  children: PropTypes.node,
};

export default Link;
